import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

import home from '@/views/home'
import homeContent from '@/views/home/content'
import newInfo from '@/views/home/new/info'
import courseEnroll from '@/views/home/course_enroll'
import courseEnrollStudent from '@/views/home/course_enroll_student'
import courseEnrollAddStudent from '@/views/home/course_enroll_add_student'
import courseEnrollSubmit from '@/views/home/course_enroll_submit'
import courseEnrollPay from '@/views/home/course_enroll_pay'
import register from '@/views/home/register'
import store from '@/views/home/store'
import xqhz from '@/views/home/xqhz'
import cxsm from '@/views/home/cxsm'
import courseDetails from '@/views/home/course_details'
import diploma from '@/views/home/diploma_search'
import diplomaInfo from '@/views/home/diploma_info'
import certificate from '@/views/home/certificate'
import studyrecord from '@/views/home/study_record'
import studylessonlog from '@/views/home/study_lesson_log'

import examcert from '@/views/examcert'
import test from '@/views/test'

import {
  ProjectSettings
} from '../config/env'

// 企业管理
const qyglHome = () => import('@/views/qygl/home');
const qyglxxglList = () => import('@/views/qygl/xxgl/list');
const qyglxyglList = () => import('@/views/qygl/xygl/list');
const qyglwdbmList = () => import('@/views/qygl/wdbm/list');
const qyglwdbkbmList = () => import('@/views/qygl/wdbkbm/list');
const qyglxxglInfo = () => import('@/views/qygl/xxgl/info');
const qyglxxglMnksjl = () => import('@/views/qygl/xxgl/mnksjl');
const qyglxyglInfo = () => import('@/views/qygl/xygl/info');
const qyglwdbmInfo = () => import('@/views/qygl/wdbm/info');
const qyglwdbmJfxx = () => import('@/views/qygl/wdbm/jfxx');
const qyglwdbkbmInfo = () => import('@/views/qygl/wdbkbm/info');
const qyglxxglbkbm = () => import('@/views/qygl/xxgl/bkbm');
const qyglfpgldkplist = () => import('@/views/qygl/fpgl/dkplist');
const qyglfpglapply = () => import('@/views/qygl/fpgl/apply');
const qyglfpglinfo = () => import('@/views/qygl/fpgl/info');
const qyglfpglList = () => import('@/views/qygl/fpgl/list');
const qygljcyfpgldkplist = () => import('@/views/qygl/jcyfpgl/dkplist');
const qygljcyfpglapply = () => import('@/views/qygl/jcyfpgl/apply');
const qygljcyfpglinfo = () => import('@/views/qygl/jcyfpgl/info');
const qygljcyfpglList = () => import('@/views/qygl/jcyfpgl/list');
const qyglzsglList = () => import('@/views/qygl/zsgl/list');
const qyglzsglInfo = () => import('@/views/qygl/zsgl/info');
const qyglzsglEdit = () => import('@/views/qygl/zsgl/edit');
const qyglzsglImport = () => import('@/views/qygl/zsgl/import');
const qyglryglList = () => import('@/views/qygl/rygl/list');
const qyglryglEdit = () => import('@/views/qygl/rygl/edit');
const qyglxmglList = () => import('@/views/qygl/xmgl/list');
const qyglxmglEdit = () => import('@/views/qygl/xmgl/edit');
const qyglWdzl = () => import('@/views/qygl/wdzl');
const qyglXgmm = () => import('@/views/qygl/xgmm');
const xyInfo = () => import('@/views/qygl/xygl/xyinfo');
const qyglxyglArchive = () => import('@/views/qygl/xygl/archive');

const qyglbdypcglList = () => import('@/views/qygl/bdypcgl/list');
const qyglbdypcglInfo = () => import('@/views/qygl/bdypcgl/info');
const qyglbdypcglAddxy = () => import('@/views/qygl/bdypcgl/addxy');

const qyglexampcglList = () => import('@/views/qygl/exampcgl/list');
const qyglexampcglInfo = () => import('@/views/qygl/exampcgl/info');
const qyglexampcglAddxy = () => import('@/views/qygl/exampcgl/addxy');

const qyglxgsqInfo = () => import('@/views/qygl/xgsq/info');
const qyglxgsqEdit = () => import('@/views/qygl/xgsq/edit');
const qyglxgsqconcatEdit = () => import('@/views/qygl/xgsq/concat_edit');

const qyglbdykqlxbmAdd = () => import('@/views/qygl/bdykqlxbm/add');
const qyglbdykqlxbmInfo = () => import('@/views/qygl/bdykqlxbm/info');
const qyglbdykqlxbmList = () => import('@/views/qygl/bdykqlxbm/list');

const qyglzjypcglList = () => import('@/views/qygl/zjypcgl/list');
const qyglzjypcglInfo = () => import('@/views/qygl/zjypcgl/info');
const qyglzjypcglAddxy = () => import('@/views/qygl/zjypcgl/addxy');

const qyglhzsqList = () => import('@/views/qygl/hzsq/list');
const qyglhzsqInfo = () => import('@/views/qygl/hzsq/info');
const qyglhzsqEdit = () => import('@/views/qygl/hzsq/edit');
const qyglhzsqApply = () => import('@/views/qygl/hzsq/apply');
const qyglhzsqMultipleEnroll = () => import('@/views/qygl/hzsq/multipleenroll');

const qyglxybgsqList = () => import('@/views/qygl/xybgsq/list');
const qyglxybgsqShlist = () => import('@/views/qygl/xybgsq/shlist');

// 运维管理
const yyglHome = () => import('@/views/yygl/home');
const qyzcshList = () => import('@/views/yygl/qyzcsh/list');
const qyzcshInfo = () => import('@/views/yygl/qyzcsh/info');
const qyzcshEdit = () => import('@/views/yygl/qyzcsh/edit');

const kcbmshList = () => import('@/views/yygl/jlypxsh/bmsh');
const kcbmshInfo = () => import('@/views/yygl/jlypxsh/info');
// const kcbmshQyinfo = () => import('@/views/yygl/kcbmsh/qyinfo'); // 作废
const kcjfshList = () => import('@/views/yygl/jlypxsh/jfsh');
// const kcktshList = () => import('@/views/yygl/kcktsh/list');
const cqjfthList = () => import('@/views/yygl/jlypxsh/cqjfth');

const jcykcbmshList = () => import('@/views/yygl/jcypxsh/bmsh');
const jcykcjfshList = () => import('@/views/yygl/jcypxsh/jfsh');
const jcycqjfthList = () => import('@/views/yygl/jcypxsh/cqjfth');

const kpsqshList = () => import('@/views/yygl/kpsqsh/list');
const kpsqshInfo = () => import('@/views/yygl/kpsqsh/info');
const kpsqshQzkp = () => import('@/views/yygl/kpsqsh/qzkp');

const jcykpsqshList = () => import('@/views/yygl/jcykpsqsh/list');
const jcykpsqshInfo = () => import('@/views/yygl/jcykpsqsh/info');
const jcykpsqshQzkp = () => import('@/views/yygl/jcykpsqsh/qzkp');

const bkbmshList = () => import('@/views/yygl/bkbmsh/list');
const bkbmshInfo = () => import('@/views/yygl/bkbmsh/info');
const bkjfshList = () => import('@/views/yygl/bkjfsh/list');
const bkktshList = () => import('@/views/yygl/bkktsh/list');

const yyglkcglList = () => import('@/views/yygl/kcgl/list');
const yyglkcglInfo = () => import('@/views/yygl/kcgl/info');

const yyglsptbrzList = () => import('@/views/yygl/sptbrz/list');

const yyglpcglList = () => import('@/views/yygl/pcgl/list');
const yyglpcglEdit = () => import('@/views/yygl/pcgl/edit');
const yyglpcglInfo = () => import('@/views/yygl/pcgl/info');
const yyglpcglAddxy = () => import('@/views/yygl/pcgl/addxy');

const yyglpxjhglList = () => import('@/views/yygl/pxjhgl/list');
const yyglpxjhglEdit = () => import('@/views/yygl/pxjhgl/edit');
const yyglpxjhglInfo = () => import('@/views/yygl/pxjhgl/info');
const yyglpxjhglAddxy = () => import('@/views/yygl/pxjhgl/addxy');

const yyglcsjhglList = () => import('@/views/yygl/csjhgl/list');
const yyglcsjhglEdit = () => import('@/views/yygl/csjhgl/edit');
const yyglcsjhglInfo = () => import('@/views/yygl/csjhgl/info');
const yyglcsjhglAddxy = () => import('@/views/yygl/csjhgl/addxy');

const yyglzjypcglList = () => import('@/views/yygl/zjypcgl/list');
const yyglzjypcglEdit = () => import('@/views/yygl/zjypcgl/edit');
const yyglzjypcglInfo = () => import('@/views/yygl/zjypcgl/info');
const yyglzjypcglShlist = () => import('@/views/yygl/zjypcgl/shlist');

const yyglqyglList = () => import('@/views/yygl/qygl/list');
const yyglqyglEdit = () => import('@/views/yygl/qygl/edit');
const yyglqyglArchive = () => import('@/views/yygl/qygl/archive');
const yyglqyglZjytest = () => import('@/views/yygl/qygl/zjytest');
const yyglqyglBdytest = () => import('@/views/yygl/qygl/bdytest');

const yyglxyglList = () => import('@/views/yygl/xygl/list');
const yyglxyglInfo = () => import('@/views/yygl/xygl/info');
const yyglxyglArchive = () => import('@/views/yygl/xygl/archive');

const yyglxxglList = () => import('@/views/yygl/xxgl/list');
const yyglxxglInfo = () => import('@/views/yygl/xxgl/info');
const yyglxxglXxkcjl = () => import('@/views/yygl/xxgl/xxkcjl');
const yyglxxglXxjl = () => import('@/views/yygl/xxgl/xxjl');
const yyglxxglXxksinfo = () => import('@/views/yygl/xxgl/xxksinfo');
const yyglxxglmnksjl = () => import('@/views/yygl/xxgl/mnksjl');

const yyglzsglList = () => import('@/views/yygl/zsgl/list');
const yyglzsglInfo = () => import('@/views/yygl/zsgl/info');

const jqcsjhglList = () => import('@/views/yygl/jqcsjhgl/list');
const jqcsjhglInfo = () => import('@/views/yygl/jqcsjhgl/info');

const xwglList = () => import('@/views/yygl/xwgl/list');
const xwglInfo = () => import('@/views/yygl/xwgl/info');
const xymddcList = () => import('@/views/yygl/xymddc/list');
const hgkscjdrList = () => import('@/views/yygl/hgkscjdr/list');
const jcy2026mddcList = () => import('@/views/yygl/jcy2026mddc/list');
const jcy2027mddcList = () => import('@/views/yygl/jcy2027mddc/list');

const yygljsgrpcglList = () => import('@/views/yygl/jsgrpcgl/list');
const yygljsgrpcglEdit = () => import('@/views/yygl/jsgrpcgl/edit');
const yygljsgrpcglInfo = () => import('@/views/yygl/jsgrpcgl/info');

const yygljsgrpxjhglList = () => import('@/views/yygl/jsgrpxjhgl/list');
const yygljsgrpxjhglEdit = () => import('@/views/yygl/jsgrpxjhgl/edit');
const yygljsgrpxjhglInfo = () => import('@/views/yygl/jsgrpxjhgl/info');
const yygljsgrpxjhglAddxy = () => import('@/views/yygl/jsgrpxjhgl/addxy');

const yygljsgrcsjhglList = () => import('@/views/yygl/jsgrcsjhgl/list');
const yygljsgrcsjhglEdit = () => import('@/views/yygl/jsgrcsjhgl/edit');
const yygljsgrcsjhglInfo = () => import('@/views/yygl/jsgrcsjhgl/info');
const yygljsgrcsjhglAddxy = () => import('@/views/yygl/jsgrcsjhgl/addxy');

const yyglcsjhpcglList = () => import('@/views/yygl/csjhpcgl/list');
const yyglcsjhpcglEdit = () => import('@/views/yygl/csjhpcgl/edit');
const yyglcsjhpcglInfo = () => import('@/views/yygl/csjhpcgl/info');
const yyglcsjhpcglAddCsjh = () => import('@/views/yygl/csjhpcgl/addcsjh');

const yyglbdypcglList = () => import('@/views/yygl/bdypcgl/list');
const yyglbdypcglEdit = () => import('@/views/yygl/bdypcgl/edit');
const yyglbdypcglInfo = () => import('@/views/yygl/bdypcgl/info');

const yyglbdycsjhglList = () => import('@/views/yygl/bdycsjhgl/list');
const yyglbdycsjhglEdit = () => import('@/views/yygl/bdycsjhgl/edit');
const yyglbdycsjhglInfo = () => import('@/views/yygl/bdycsjhgl/info');
const yyglbdycsjhglAddxy = () => import('@/views/yygl/bdycsjhgl/addxy');

const yyglexampcglList = () => import('@/views/yygl/exampcgl/list');
const yyglexampcglEdit = () => import('@/views/yygl/exampcgl/edit');
const yyglexampcglInfo = () => import('@/views/yygl/exampcgl/info');

const yyglexamjhglList = () => import('@/views/yygl/examjhgl/list');
const yyglexamjhglEdit = () => import('@/views/yygl/examjhgl/edit');
const yyglexamjhglInfo = () => import('@/views/yygl/examjhgl/info');
const yyglexamjhglAddxy = () => import('@/views/yygl/examjhgl/addxy');
const yyglexamjhglApprovepaper = () => import('@/views/yygl/examjhgl/approvepaper');

const yyglqyxgsqglList = () => import('@/views/yygl/qyxgsqgl/list');
const yyglqyxgsqglInfo = () => import('@/views/yygl/qyxgsqgl/info');

const yyglbdykqlxshInfo = () => import('@/views/yygl/bdykqlxsh/info');
const yyglbdykqlxshList = () => import('@/views/yygl/bdykqlxsh/list');

const yyglsdytmglList = () => import('@/views/yygl/sdytmgl/list');

const yyglGkKpglList = () => import('@/views/yygl/kpgl/gklist');
const yyglPxKpglList = () => import('@/views/yygl/kpgl/pxlist');

const yyglhzcsshList = () => import('@/views/yygl/hzcssh/list');
const yyglhzfsshList = () => import('@/views/yygl/hzfssh/list');
const yyglhzcsshInfo = () => import('@/views/yygl/hzcssh/info');
const yyglxybgsqList = () => import('@/views/yygl/xybgsq/list');

// 在线学习管理
const zxxxglHome = () => import('@/views/zxxxgl/home');
const wdxxHome = () => import('@/views/zxxxgl/wdxx/list');
const wdxxInfo = () => import('@/views/zxxxgl/wdxx/info');
const wdxxAlbum = () => import('@/views/zxxxgl/wdxx/album');
const exercises = () => import('@/views/zxxxgl/wdxx/exercises');
const wkExercises = () => import('@/views/zxxxgl/wdxx/wkExercises');
const hgExercises = () => import('@/views/zxxxgl/wdxx/hgExercises');
const wdxxVideo = () => import('@/views/zxxxgl/wdxx/video');
const xxglksdf = () => import('@/views/zxxxgl/ksdf');
const zxxxglxyInfo = () => import('@/views/zxxxgl/xyinfo');
const wkzsPage = () => import('@/views/zxxxgl/wkzs');
const zkzPage = () => import('@/views/zxxxgl/zkz');

const zxxxglzsglList = () => import('@/views/zxxxgl/zsgl/list');
const zxxxglzsglInfo = () => import('@/views/zxxxgl/zsgl/info');

const wdzlHome = () => import('@/views/zxxxgl/wdzl');
const xgmmHome = () => import('@/views/zxxxgl/xgmm');

Vue.use(Router);

Router.prototype.goBack = function() {
  this.isBack = true;
  this.go(-1);
};

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: home,
      redirect: '/index',
      children: [
        {
          path: 'index',
          name: 'index',
          component: homeContent
        },
        {
          path: 'notice',
          name: 'notice',
          component: newInfo,
          meta: {
            title: '通知公告'
          }
        },
        {
          path: 'courseEnroll',
          name: 'courseEnroll',
          component: courseEnroll,
          meta: {
            title: '培训报名'
          }
        },
        {
          path: 'courseEnrollStudent',
          name: 'courseEnrollStudent',
          component: courseEnrollStudent,
          meta: {
            title: '选择学员 - 培训报名'
          }
        },
        {
          path: 'courseEnrollAddStudent',
          name: 'courseEnrollAddStudent',
          component: courseEnrollAddStudent,
          meta: {
            title: '添加学员 - 培训报名'
          }
        },
        {
          path: 'courseEnrollSubmit',
          name: 'courseEnrollSubmit',
          component: courseEnrollSubmit,
          meta: {
            title: '确认报名'
          }
        },
        {
          path: 'courseEnrollPay',
          name: 'courseEnrollPay',
          component: courseEnrollPay,
          meta: {
            title: '在线支付 - 培训报名'
          }
        },
        {
          path: 'register',
          name: 'register',
          component: register,
          meta: {
            title: '企业注册'
          }
        },
        {
          path: 'store',
          name: 'store',
          component: store,
          meta: {
            title: '培训报名'
          }
        },
        {
          path: 'xqhz',
          name: 'xqhz',
          component: xqhz,
          meta: {
            title: '校企合作'
          }
        },
        {
          path: 'cxsm',
          name: 'cxsm',
          component: cxsm,
          meta: {
            title: '初心使命'
          }
        },
        {
          path: 'courseDetails',
          name: 'courseDetails',
          component: courseDetails,
          meta: {
            title: '培训详情'
          }
        },
        {
          path: 'diploma',
          name: 'diploma',
          component: diploma,
          meta: {
            title: '证书查询'
          }
        },
        {
          path: 'diplomainfo',
          name: 'diplomainfo',
          component: diplomaInfo,
          meta: {
            title: '证书信息'
          }
        },
        {
          path: 'certificate',
          name: 'certificate',
          component: certificate
        },
        {
          path: 'studyrecord',
          name: 'studyrecord',
          component: studyrecord,
          meta: {
            title: '学习记录查询'
          }
        },
        {
          path: 'studylessonlog',
          name: 'studylessonlog',
          component: studylessonlog,
          meta: {
            title: '课时学习记录'
          }
        },
        {
          path: 'qygl',
          name: 'qygl',
          component: qyglHome,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/qygl/xxgl',
              name: 'qyglxxgl',
              component: qyglxxglList,
              meta: {
                requiresAuth: true,
                title: '学习管理'
              }
            },
            {
              path: '/qygl/xygl',
              name: 'qyglxygl',
              component: qyglxyglList,
              meta: {
                requiresAuth: true,
                title: '学员管理'
              }
            },
            {
              // 作废
              path: '/qygl/xygl/info',
              name: 'qyglxyglinfo',
              component: qyglxyglInfo,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: '/qygl/wdbm',
              name: 'qyglwdbm',
              component: qyglwdbmList,
              meta: {
                requiresAuth: true,
                title: '我的培训报名'
              }
            },
            {
              path: '/qygl/wdbkbm',
              name: 'qyglwdbkbm',
              component: qyglwdbkbmList,
              meta: {
                requiresAuth: true,
                title: '我的补考报名'
              }
            },
            {
              path: '/qygl/xyinfo',
              name: 'qyglxyinfo',
              component: xyInfo,
              meta: {
                requiresAuth: true,
                title: '详情 - 学员管理'
              }
            },
            {
              path: '/qygl/fpgl/dkplist',
              name: 'qyglsqkp',
              component: qyglfpgldkplist,
              meta: {
                requiresAuth: true,
                title: '监理人员申请开票'
              }
            },
            {
              path: '/qygl/fpgl/apply',
              name: 'qyglfpglapply',
              component: qyglfpglapply,
              meta: {
                requiresAuth: true,
                title: '监理人员申请开票'
              }
            },
            {
              path: '/qygl/fpgl/info',
              name: 'qyglfpglinfo',
              component: qyglfpglinfo,
              meta: {
                requiresAuth: true,
                title: '详情 - 监理人员发票下载'
              }
            },
            {
              path: '/qygl/fpgl/list',
              name: 'qyglkpls',
              component: qyglfpglList,
              meta: {
                requiresAuth: true,
                title: '监理人员发票下载'
              }
            },
            {
              path: '/qygl/jcyfpgl/dkplist',
              name: 'qygljcysqkp',
              component: qygljcyfpgldkplist,
              meta: {
                requiresAuth: true,
                title: '检测人员申请开票'
              }
            },
            {
              path: '/qygl/jcyfpgl/apply',
              name: 'qygljcyfpglapply',
              component: qygljcyfpglapply,
              meta: {
                requiresAuth: true,
                title: '检测人员申请开票'
              }
            },
            {
              path: '/qygl/jcyfpgl/info',
              name: 'qygljcyfpglinfo',
              component: qygljcyfpglinfo,
              meta: {
                requiresAuth: true,
                title: '详情 - 检测人员发票下载'
              }
            },
            {
              path: '/qygl/jcyfpgl/list',
              name: 'qygljcykpls',
              component: qygljcyfpglList,
              meta: {
                requiresAuth: true,
                title: '检测人员发票下载'
              }
            },
            {
              path: '/qygl/zsgl/list',
              name: 'qyglzsgl',
              component: qyglzsglList,
              meta: { requiresAuth: true }
            },
            {
              path: '/qygl/zsgl/info',
              name: 'qyglzsglinfo',
              component: qyglzsglInfo,
              meta: { requiresAuth: true }
            },
            {
              // 作废
              path: '/qygl/zsgl/edit',
              name: 'qyglzsgledit',
              component: qyglzsglEdit,
              meta: { requiresAuth: true }
            },
            {
              // 作废
              path: '/qygl/zsgl/import',
              name: 'qyglzsglimport',
              component: qyglzsglImport,
              meta: { requiresAuth: true }
            },
            {
              // 作废
              path: '/qygl/rygl/list',
              name: 'qyglrygl',
              component: qyglryglList,
              meta: { requiresAuth: true }
            },
            {
              // 作废
              path: '/qygl/rygl/edit',
              name: 'qyglrygledit',
              component: qyglryglEdit,
              meta: { requiresAuth: true }
            },
            {
              // 作废
              path: '/qygl/xmgl/list',
              name: 'qyglxmgl',
              component: qyglxmglList,
              meta: { requiresAuth: true }
            },
            {
              // 作废
              path: '/qygl/xmgl/edit',
              name: 'qyglxmgledit',
              component: qyglxmglEdit,
              meta: { requiresAuth: true }
            },
            {
              path: '/qygl/wdzl',
              name: 'qyglwdzl',
              component: qyglWdzl,
              meta: {
                requiresAuth: true,
                title: '我的资料'
              }
            },
            {
              // 作废
              path: '/qygl/xgmm',
              name: 'qyglxgmm',
              component: qyglXgmm,
              meta: { requiresAuth: true }
            },
            {
              path: '/qygl/bdypcgl',
              name: 'qyglbdypcgl',
              component: qyglbdypcglList,
              meta: {
                requiresAuth: true,
                title: '十大员测试报名'
              }
            },
            {
              path: '/qygl/exampcgl',
              name: 'qyglexampcgl',
              component: qyglexampcglList,
              meta: {
                requiresAuth: true,
                title: '测试报名'
              }
            },
            {
              path: '/qygl/xgsq/edit',
              name: 'qyglxgsqedit',
              component: qyglxgsqEdit,
              meta: {
                requiresAuth: true,
                title: '企业信息变更'
              }
            },
            {
              path: '/qygl/xgsq/concatedit',
              name: 'qyglxgsqconcatedit',
              component: qyglxgsqconcatEdit,
              meta: {
                requiresAuth: true,
                title: '企业联系信息变更'
              }
            },
            {
              path: '/qygl/xgsq/info',
              name: 'qyglxgsqinfo',
              component: qyglxgsqInfo,
              meta: {
                requiresAuth: true,
                title: '详情 - 企业信息变更'
              }
            },
            {
              path: '/qygl/bdykqlxbm',
              name: 'qyglbdykqlxbm',
              component: qyglbdykqlxbmList,
              meta: {
                requiresAuth: true,
                title: '十大员考前练习报名'
              }
            },
            {
              path: '/qygl/zjypcgl',
              name: 'qyglzjypcgl',
              component: qyglzjypcglList,
              meta: {
                requiresAuth: true,
                title: '三类特种测试报名'
              }
            },
            {
              path: '/qygl/hzsq',
              name: 'qyglhzsq',
              component: qyglhzsqList,
              meta: {
                requiresAuth: true,
                title: '换证申请'
              }
            },
            {
              path: '/qygl/hzsq/apply',
              name: 'qyglhzsqapply',
              component: qyglhzsqApply,
              meta: {
                requiresAuth: true,
                title: '申请换证'
              }
            },
            {
              path: '/qygl/hzsq/multipleenroll',
              name: 'qyglhzsqmultipleenroll',
              component: qyglhzsqMultipleEnroll,
              meta: {
                requiresAuth: true,
                title: '换证申请-批量激活'
              }
            },
            {
              path: '/qygl/hzsq/info',
              name: 'qyglhzsqinfo',
              component: qyglhzsqInfo,
              meta: {
                requiresAuth: true,
                title: '换证申请详情'
              }
            },
            {
              path: '/qygl/hzsq/edit',
              name: 'qyglhzsqedit',
              component: qyglhzsqEdit,
              meta: {
                requiresAuth: true,
                title: '修改换证申请'
              }
            },
            {
              path: '/qygl/xybgsq/list',
              name: 'qyglxybgsq',
              component: qyglxybgsqList,
              meta: {
                requiresAuth: true,
                title: '学员变更申请-我的申请'
              }
            },
            {
              path: '/qygl/xybgsq/shlist',
              name: 'qyglxybgsqsh',
              component: qyglxybgsqShlist,
              meta: {
                requiresAuth: true,
                title: '学员变更申请-审核列表'
              }
            }
          ]
        },
        {
          path: '/yygl',
          name: 'yygl',
          component: yyglHome,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/yygl/qyzcsh',
              name: 'qyzcsh',
              component: qyzcshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '企业注册审核'
              }
            },
            {
              path: '/yygl/qyzcshedit',
              name: 'qyzcshedit',
              component: qyzcshEdit,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '企业注册审核'
              }
            },
            {
              path: '/yygl/kcbmsh',
              name: 'kcbmsh',
              component: kcbmshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '监理人员培训报名审核'
              }
            },
            {
              path: '/yygl/kcjfsh',
              name: 'kcjfsh',
              component: kcjfshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '监理人员培训缴费审核'
              }
            },
            {
              path: '/yygl/cqjfth',
              name: 'cqjfth',
              component: cqjfthList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '监理人员超期缴费退回'
              }
            },
            {
              path: '/yygl/jcykcbmsh',
              name: 'jcykcbmsh',
              component: jcykcbmshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员培训报名审核'
              }
            },
            {
              path: '/yygl/jcykcjfsh',
              name: 'jcykcjfsh',
              component: jcykcjfshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员培训缴费审核'
              }
            },
            {
              path: '/yygl/jcycqjfth',
              name: 'jcycqjfth',
              component: jcycqjfthList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员超期缴费退回'
              }
            },
            {
              path: '/yygl/kpsqsh',
              name: 'kpsqsh',
              component: kpsqshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '监理人员开票申请审核'
              }
            },
            {
              path: '/yygl/kpsqshinfo',
              name: 'kpsqshinfo',
              component: kpsqshInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '详情 - 监理人员开票申请审核'
              }
            },
            {
              path: '/yygl/kpsqshqzkp',
              name: 'kpsqshqzkp',
              component: kpsqshQzkp,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '监理人员批量强制开票'
              }
            },
            {
              path: '/yygl/jcykpsqsh',
              name: 'jcykpsqsh',
              component: jcykpsqshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员开票申请审核'
              }
            },
            {
              path: '/yygl/jcykpsqsh',
              name: 'jcykpsqsh1',
              component: jcykpsqshList,
              props: { t: 1 },
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员 - 无合同开普票'
              }
            },
            {
              path: '/yygl/jcykpsqsh',
              name: 'jcykpsqsh2',
              component: jcykpsqshList,
              props: { t: 2 },
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员 - 有合同开普票'
              }
            },
            {
              path: '/yygl/jcykpsqsh',
              name: 'jcykpsqsh3',
              component: jcykpsqshList,
              props: { t: 3 },
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员 - 有合同开专票'
              }
            },
            {
              path: '/yygl/jcykpsqshinfo',
              name: 'jcykpsqshinfo',
              component: jcykpsqshInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '详情 - 检测人员开票申请审核'
              }
            },
            {
              path: '/yygl/jcykpsqshqzkp',
              name: 'jcykpsqshqzkp',
              component: jcykpsqshQzkp,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测人员批量强制开票'
              }
            },
            {
              path: '/yygl/bkbmsh',
              name: 'bkbmsh',
              component: bkbmshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '补考报名审核'
              }
            },
            {
              path: '/yygl/bkjfsh',
              name: 'bkjfsh',
              component: bkjfshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '补考缴费审核'
              }
            },
            {
              path: '/yygl/bkktsh',
              name: 'bkktsh',
              component: bkktshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '补考开通审核'
              }
            },
            {
              path: '/yygl/pxjhgl',
              name: 'pxjhgl',
              component: yyglpxjhglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '十大员培训计划管理'
              }
            },
            {
              path: '/yygl/pxjhgledit',
              name: 'yyglpxjhgledit',
              component: yyglpxjhglEdit,
              meta: {
                requiresAuth: true,
                title: '十大员培训计划管理'
              }
            },
            {
              path: '/yygl/csjhgl',
              name: 'csjhgl',
              component: yyglcsjhglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '十大员测试计划管理'
              }
            },
            {
              path: '/yygl/csjhgledit',
              name: 'yyglcsjhgledit',
              component: yyglcsjhglEdit,
              meta: {
                requiresAuth: true,
                title: '十大员测试计划管理'
              }
            },
            {
              path: '/yygl/pcgl',
              name: 'pcgl',
              component: yyglpcglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '十大员学习批次管理'
              }
            },
            {
              path: '/yygl/pcgledit',
              name: 'yyglpcgledit',
              component: yyglpcglEdit,
              meta: {
                requiresAuth: true,
                title: '十大员学习批次管理'
              }
            },
            {
              // 作废
              path: '/yygl/pcgladdxy',
              name: 'yyglpcgladdxy',
              component: yyglpcglAddxy,
              meta: {
                requiresAuth: true,
                title: '添加学员 - 十大员学习批次管理'
              }
            },
            {
              path: '/yygl/kcgl',
              name: 'kcgl',
              component: yyglkcglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '考场管理'
              }
            },
            {
              path: '/yygl/kcglinfo',
              name: 'yyglkcglinfo',
              component: yyglkcglInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '考场管理'
              }
            },
            {
              path: '/yygl/sptbrz',
              name: 'sptbrz',
              component: yyglsptbrzList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '十大员必修同步日志'
              }
            },
            {
              path: '/yygl/zjypcgl/shlist',
              name: 'zjypcglshlist',
              component: yyglzjypcglShlist,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '三类特种测试报名审核'
              }
            },
            {
              path: '/yygl/zjypcgl',
              name: 'zjypcgl',
              component: yyglzjypcglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '三类特种测试批次管理'
              }
            },
            {
              path: '/yygl/zjypcgledit',
              name: 'yyglzjypcgledit',
              component: yyglzjypcglEdit,
              meta: {
                requiresAuth: true,
                title: '三类特种测试批次管理'
              }
            },
            {
              path: '/yygl/qygl',
              name: 'yyglqygl',
              component: yyglqyglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '企业管理'
              }
            },
            {
              path: '/yygl/qygledit',
              name: 'yyglqygledit',
              component: yyglqyglEdit,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '修改 - 企业管理'
              }
            },
            {
              path: '/yygl/xygl',
              name: 'yyglxygl',
              component: yyglxyglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '学员管理'
              }
            },
            {
              path: '/yygl/xyglinfo',
              name: 'yyglxyglinfo',
              component: yyglxyglInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '详情 - 学员管理'
              }
            },
            {
              path: '/yygl/xxgl',
              name: 'yyglxxgl',
              component: yyglxxglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '学习管理'
              }
            },
            {
              path: '/yygl/zsgl',
              name: 'yyglzsgl',
              component: yyglzsglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '证书管理'
              }
            },
            {
              path: '/yygl/zsglinfo',
              name: 'yyglzsglinfo',
              component: yyglzsglInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '证书详情'
              }
            },
            {
              path: '/yygl/jqcsjhgl',
              name: 'jqcsjhgl',
              component: jqcsjhglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '测试安排管理'
              }
            },
            {
              path: '/yygl/jqcsjhglinfo',
              name: 'jqcsjhglinfo',
              component: jqcsjhglInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '测试安排管理'
              }
            },
            {
              path: '/yygl/xwgl',
              name: 'xwgl',
              component: xwglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '新闻管理'
              }
            },
            {
              path: '/yygl/xwglinfo',
              name: 'xwglinfo',
              component: xwglInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '新闻管理'
              }
            },
            {
              path: '/yygl/xymddc',
              name: 'xymddc',
              component: xymddcList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '学员名单导出'
              }
            },
            {
              path: '/yygl/jcy2026mddc',
              name: 'jcy2026mddc',
              component: jcy2026mddcList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测员 2026 年度延期名单导出'
              }
            },
            {
              path: '/yygl/jcy2027mddc',
              name: 'jcy2027mddc',
              component: jcy2027mddcList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '检测员 2027 年度延期名单导出'
              }
            },
            {
              // 作废
              path: '/yygl/hgkscjdr',
              name: 'hgkscjdr',
              component: hgkscjdrList,
              meta: { requiresAuth: true }
            },
            {
              path: '/yygl/jsgrpcgl',
              name: 'jsgrpcgl',
              component: yygljsgrpcglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '技术工人学习批次管理'
              }
            },
            {
              path: '/yygl/jsgrpcgledit',
              name: 'yygljsgrpcgledit',
              component: yygljsgrpcglEdit,
              meta: {
                requiresAuth: true,
                title: '技术工人学习批次管理'
              }
            },
            {
              path: '/yygl/jsgrpxjhgl',
              name: 'jsgrpxjhgl',
              component: yygljsgrpxjhglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '技术工人培训计划管理'
              }
            },
            {
              path: '/yygl/jsgrpxjhgledit',
              name: 'yygljsgrpxjhgledit',
              component: yygljsgrpxjhglEdit,
              meta: {
                requiresAuth: true,
                title: '技术工人培训计划管理'
              }
            },
            {
              path: '/yygl/jsgrcsjhgl',
              name: 'jsgrcsjhgl',
              component: yygljsgrcsjhglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '技术工人测试计划管理'
              }
            },
            {
              path: '/yygl/jsgrcsjhgledit',
              name: 'yygljsgrcsjhgledit',
              component: yygljsgrcsjhglEdit,
              meta: {
                requiresAuth: true,
                title: '技术工人测试计划管理'
              }
            },
            {
              // 作废
              path: '/yygl/csjhpcgl',
              name: 'csjhpcgl',
              component: yyglcsjhpcglList,
              meta: {
                requiresAuth: true,
                keepAlive: true
              }
            },
            {
              // 作废
              path: '/yygl/csjhpcgledit',
              name: 'yyglcsjhpcgledit',
              component: yyglcsjhpcglEdit,
              meta: { requiresAuth: true }
            },
            {
              path: '/yygl/bdypcgl',
              name: 'bdypcgl',
              component: yyglbdypcglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '十大员测试批次管理'
              }
            },
            {
              path: '/yygl/bdypcgledit',
              name: 'yyglbdypcgledit',
              component: yyglbdypcglEdit,
              meta: {
                requiresAuth: true,
                title: '十大员测试批次管理'
              }
            },
            {
              // 作废
              path: '/yygl/bdycsjhgl',
              name: 'bdycsjhgl',
              component: yyglbdycsjhglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '测试计划 - 十大员测试批次管理'
              }
            },
            {
              path: '/yygl/bdycsjhgledit',
              name: 'yyglbdycsjhgledit',
              component: yyglbdycsjhglEdit,
              meta: {
                requiresAuth: true,
                title: '测试计划 - 十大员测试批次管理'
              }
            },
            {
              path: '/yygl/exampcgl',
              name: 'exampcgl',
              component: yyglexampcglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '测试批次管理'
              }
            },
            {
              path: '/yygl/exampcgledit',
              name: 'yyglexampcgledit',
              component: yyglexampcglEdit,
              meta: {
                requiresAuth: true,
                title: '测试批次管理'
              }
            },
            {
              // 作废
              path: '/yygl/examjhgl',
              name: 'examjhgl',
              component: yyglexamjhglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '测试计划 - 测试批次管理'
              }
            },
            {
              path: '/yygl/examjhgledit',
              name: 'yyglexamjhgledit',
              component: yyglexamjhglEdit,
              meta: {
                requiresAuth: true,
                title: '测试计划 - 测试批次管理'
              }
            },
            {
              path: '/yygl/qyxgsqgl',
              name: 'qyxgsqgl',
              component: yyglqyxgsqglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '企业信息变更审核'
              }
            },
            {
              path: '/yygl/qyxgsqglinfo',
              name: 'yyglqyxgsqglinfo',
              component: yyglqyxgsqglInfo,
              meta: {
                requiresAuth: true,
                title: '详情 - 企业信息变更审核'
              }
            },
            {
              path: '/yygl/bdykqlxsh',
              name: 'bdykqlxsh',
              component: yyglbdykqlxshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '十大员考前练习审核'
              }
            },
            {
              path: '/yygl/sdytmgl',
              name: 'sdytmgl',
              component: yyglsdytmglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '题库查询'
              }
            },
            {
              path: '/yygl/gkkpgl',
              name: 'yyglgkkpgl',
              component: yyglGkKpglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '国控教育开票管理'
              }
            },
            {
              path: '/yygl/pxkpgl',
              name: 'yyglpxkpgl',
              component: yyglPxKpglList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '培训学校开票管理'
              }
            },
            {
              path: '/yygl/hzcssh',
              name: 'hzcssh',
              component: yyglhzcsshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '换证初审审核'
              }
            },
            {
              path: '/yygl/hzfssh',
              name: 'hzfssh',
              component: yyglhzfsshList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '换证复审审核'
              }
            },
            {
              path: '/yygl/hzcssh/info',
              name: 'hzcsshinfo',
              component: yyglhzcsshInfo,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '换证申请详情'
              }
            },
            {
              path: '/yygl/xybgsq/list',
              name: 'yyglxybgsq',
              component: yyglxybgsqList,
              meta: {
                requiresAuth: true,
                keepAlive: true,
                title: '学员变更申请记录'
              }
            }
          ]
        },
        {
          path: '/zxxxgl',
          name: 'zxxxgl',
          component: zxxxglHome,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/zxxxgl/wdxx',
              name: 'wdxx',
              component: wdxxHome,
              meta: {
                requiresAuth: true,
                title: '我的学习'
              }
            },
            {
              // 作废
              path: '/zxxxgl/wdzl',
              name: 'wdzl',
              component: wdzlHome,
              meta: {
                requiresAuth: true,
                title: '我的资料'
              }
            },
            {
              // 作废
              path: '/zxxxgl/xgmm',
              name: 'xgmm',
              component: xgmmHome,
              meta: { requiresAuth: true }
            },
            {
              path: '/zxxxgl/xyinfo',
              name: 'zxxxglxyinfo',
              component: zxxxglxyInfo,
              meta: {
                requiresAuth: true,
                title: '我的资料'
              }
            },
            {
              path: '/zxxxgl/zsgl/list',
              name: 'zxxxglzsgl',
              component: zxxxglzsglList,
              meta: {
                requiresAuth: true,
                title: '我的证书'
              }
            },
            {
              path: '/zxxxgl/zsgl/info',
              name: 'zxxxglzsglinfo',
              component: zxxxglzsglInfo,
              meta: {
                requiresAuth: true,
                title: '证书详情'
              }
            }
          ]
        },
        {
          path: '/yygl/kcbmshinfo',
          name: 'kcbmshinfo',
          component: kcbmshInfo,
          meta: {
            requiresAuth: true,
            title: '培训报名审核'
          }
        },
        // {
        //   // 作废
        //   path: '/yygl/kcbmshqyinfo',
        //   name: 'kcbmshqyinfo',
        //   component: kcbmshQyinfo,
        //   meta: { requiresAuth: true }
        // },
        {
          path: '/yygl/bkbmshinfo',
          name: 'bkbmshinfo',
          component: bkbmshInfo,
          meta: {
            requiresAuth: true,
            title: '补考报名审核'
          }
        },
        {
          path: '/yygl/pcglinfo',
          name: 'yyglpcglinfo',
          component: yyglpcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 十大员学习批次管理'
          }
        },
        {
          path: '/yygl/pxjhglinfo',
          name: 'yyglpxjhglinfo',
          component: yyglpxjhglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 十大员培训计划管理'
          }
        },
        {
          path: '/yygl/pxjhgladdxy',
          name: 'yyglpxjhgladdxy',
          component: yyglpxjhglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 十大员培训计划管理'
          }
        },
        {
          path: '/yygl/csjhglinfo',
          name: 'yyglcsjhglinfo',
          component: yyglcsjhglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 十大员测试计划管理'
          }
        },
        {
          path: '/yygl/csjhgladdxy',
          name: 'yyglcsjhgladdxy',
          component: yyglcsjhglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 十大员测试计划管理'
          }
        },
        {
          path: '/yygl/zjypcglinfo',
          name: 'yyglzjypcglinfo',
          component: yyglzjypcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 三类特种测试批次管理'
          }
        },
        {
          path: '/yygl/xxzx/info',
          name: 'xxzxinfo',
          component: yyglxxglInfo,
          meta: {
            requiresAuth: true,
            title: '学习详情'
          }
        },
        {
          path: '/yygl/xxgl/xxksinfo',
          name: 'yyglxxglxxksinfo',
          component: yyglxxglXxksinfo,
          meta: {
            requiresAuth: true,
            title: '课时详情 - 学习详情'
          }
        },
        {
          path: '/yygl/xxgl/mnksjl',
          name: 'yyglxxglmnksjl',
          component: yyglxxglmnksjl,
          meta: {
            requiresAuth: true,
            title: '模拟测试记录 - 学习详情'
          }
        },
        {
          path: '/yygl/xxgl/xxjl',
          name: 'yyglxxglxxjl',
          component: yyglxxglXxjl,
          meta: {
            requiresAuth: true,
            title: '课时学习记录 - 课时详情 - 学习详情'
          }
        },
        {
          path: '/yygl/xxgl/xxkcjl',
          name: 'yyglxxglxxkcjl',
          component: yyglxxglXxkcjl,
          meta: {
            requiresAuth: true,
            title: '学习课程记录 - 培训详情 - 学习详情'
          }
        },
        {
          path: '/qygl/wdbm/info',
          name: 'qyglwdbminfo',
          component: qyglwdbmInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 我的报名'
          }
        },
        {
          path: '/qygl/wdbm/jfxx',
          name: 'qyglwdbmjfxx',
          component: qyglwdbmJfxx,
          meta: {
            requiresAuth: true,
            title: '详情 - 上传缴费信息'
          }
        },
        {
          path: '/qygl/wdbkbm/info',
          name: 'qyglwdbkbminfo',
          component: qyglwdbkbmInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 我的补考报名'
          }
        },
        {
          path: '/qygl/xxgl/info',
          name: 'qyglxxglinfo',
          component: qyglxxglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 学习管理'
          }
        },
        {
          path: '/qygl/xxgl/mnksjl',
          name: 'qyglxxglmnksjl',
          component: qyglxxglMnksjl,
          meta: {
            requiresAuth: true,
            title: '模拟测试记录 - 学习管理'
          }
        },
        {
          path: '/qygl/xxgl/bkbm',
          name: 'qyglxxglbkbm',
          component: qyglxxglbkbm,
          meta: {
            requiresAuth: true,
            title: '补考报名 - 学习管理'
          }
        },
        {
          path: '/zxxxgl/wdxxinfo',
          name: 'wdxxinfo',
          component: wdxxInfo,
          meta: {
            requiresAuth: true,
            title: '学习详情'
          }
        },
        {
          path: '/zxxxgl/wdxxalbum',
          name: 'wdxxalbum',
          component: wdxxAlbum,
          meta: {
            requiresAuth: true,
            title: '学习课时详情'
          }
        },
        {
          path: '/zxxxgl/wkzs',
          name: 'wkzs',
          component: wkzsPage,
          meta: {
            requiresAuth: true,
            title: '完课证明'
          }
        },
        {
          // 作废
          path: '/zxxxgl/zkz',
          name: 'zkz',
          component: zkzPage,
          meta: {
            requiresAuth: true,
            title: '准考证'
          }
        },
        {
          // 作废
          path: '/yygl/qyzcshinfo',
          name: 'qyzcshinfo',
          component: qyzcshInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 企业注册审核'
          }
        },
        {
          path: '/yygl/jsgrpcglinfo',
          name: 'yygljsgrpcglinfo',
          component: yygljsgrpcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 技术工人学习批次管理'
          }
        },
        {
          path: '/yygl/jsgrpxjhglinfo',
          name: 'yygljsgrpxjhglinfo',
          component: yygljsgrpxjhglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 技术工人培训计划管理'
          }
        },
        {
          path: '/yygl/jsgrpxjhgladdxy',
          name: 'yygljsgrpxjhgladdxy',
          component: yygljsgrpxjhglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 技术工人培训计划管理'
          }
        },
        {
          path: '/yygl/jsgrcsjhglinfo',
          name: 'yygljsgrcsjhglinfo',
          component: yygljsgrcsjhglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 技术工人测试计划管理'
          }
        },
        {
          path: '/yygl/jsgrcsjhgladdxy',
          name: 'yygljsgrcsjhgladdxy',
          component: yygljsgrcsjhglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 技术工人测试计划管理'
          }
        },
        {
          // 作废
          path: '/yygl/csjhpcglinfo',
          name: 'yyglcsjhpcglinfo',
          component: yyglcsjhpcglInfo,
          meta: { requiresAuth: true }
        },
        {
          // 作废
          path: '/yygl/csjhpcgladdcsjh',
          name: 'yyglcsjhpcgladdcsjh',
          component: yyglcsjhpcglAddCsjh,
          meta: { requiresAuth: true }
        },
        {
          path: '/yygl/bdypcglinfo',
          name: 'yyglbdypcglinfo',
          component: yyglbdypcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 十大员测试批次管理'
          }
        },
        {
          path: '/yygl/bdycsjhglinfo',
          name: 'yyglbdycsjhglinfo',
          component: yyglbdycsjhglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 测试计划 - 十大员测试批次管理'
          }
        },
        {
          path: '/yygl/bdycsjhgladdxy',
          name: 'yyglbdycsjhgladdxy',
          component: yyglbdycsjhglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 测试计划 - 十大员测试批次管理'
          }
        },
        {
          path: '/yygl/exampcglinfo',
          name: 'yyglexampcglinfo',
          component: yyglexampcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 测试批次管理'
          }
        },
        {
          path: '/yygl/examjhglinfo',
          name: 'yyglexamjhglinfo',
          component: yyglexamjhglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 测试计划 - 测试批次管理'
          }
        },
        {
          path: '/yygl/examjhgladdxy',
          name: 'yyglexamjhgladdxy',
          component: yyglexamjhglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 测试计划 - 测试批次管理'
          }
        },
        {
          path: '/yygl/examjhglapprovepaper',
          name: 'yyglexamjhglapprovepaper',
          component: yyglexamjhglApprovepaper,
          meta: {
            requiresAuth: true,
            title: '审核学员 - 测试计划 - 测试批次管理'
          }
        },
        {
          path: '/yygl/bdykqlxshinfo',
          name: 'yyglbdykqlxshinfo',
          component: yyglbdykqlxshInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 十大员考前练习审核'
          }
        },
        {
          path: '/yygl/qygl/archive',
          name: 'yyglqyglarchive',
          component: yyglqyglArchive,
          meta: {
            requiresAuth: true,
            title: '企业档案'
          }
        },
        {
          path: '/yygl/qygl/zjytest',
          name: 'yyglqyglzjytest',
          component: yyglqyglZjytest,
          meta: {
            requiresAuth: true,
            title: '企业测试详情'
          }
        },
        {
          path: '/yygl/qygl/bdytest',
          name: 'yyglqyglbdytest',
          component: yyglqyglBdytest,
          meta: {
            requiresAuth: true,
            title: '企业测试详情'
          }
        },
        {
          path: '/yygl/xygl/archive',
          name: 'yyglxyglarchive',
          component: yyglxyglArchive,
          meta: {
            requiresAuth: true,
            title: '学员档案'
          }
        },
        {
          path: '/qygl/bdypcglinfo',
          name: 'qyglbdypcglinfo',
          component: qyglbdypcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 十大员测试报名'
          }
        },
        {
          path: '/qygl/bdypcgladdxy',
          name: 'qyglbdypcgladdxy',
          component: qyglbdypcglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 十大员测试报名'
          }
        },
        {
          path: '/qygl/exampcglinfo',
          name: 'qyglexampcglinfo',
          component: qyglexampcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 测试报名'
          }
        },
        {
          path: '/qygl/exampcgladdxy',
          name: 'qyglexampcgladdxy',
          component: qyglexampcglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 测试报名'
          }
        },
        {
          path: '/qygl/bdykqlxbmadd',
          name: 'qyglbdykqlxbmadd',
          component: qyglbdykqlxbmAdd,
          meta: {
            requiresAuth: true,
            title: '添加 - 十大员考前练习报名'
          }
        },
        {
          path: '/qygl/bdykqlxbminfo',
          name: 'qyglbdykqlxbminfo',
          component: qyglbdykqlxbmInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 十大员考前练习报名'
          }
        },
        {
          path: '/qygl/xygl/archive',
          name: 'qyglxyglarchive',
          component: qyglxyglArchive,
          meta: {
            requiresAuth: true,
            title: '学员档案'
          }
        },
        {
          path: '/qygl/zjypcglinfo',
          name: 'qyglzjypcglinfo',
          component: qyglzjypcglInfo,
          meta: {
            requiresAuth: true,
            title: '详情 - 三类特种测试报名'
          }
        },
        {
          path: '/qygl/zjypcgladdxy',
          name: 'qyglzjypcgladdxy',
          component: qyglzjypcglAddxy,
          meta: {
            requiresAuth: true,
            title: '添加学员 - 三类特种测试报名'
          }
        }
      ]
    },
    {
      path: '/zxxxgl/exercises',
      name: 'exercises',
      component: exercises,
      meta: {
        requiresAuth: true,
        title: '课时练习'
      }
    },
    {
      path: '/zxxxgl/wkexercises',
      name: 'wkexercises',
      component: wkExercises,
      meta: {
        requiresAuth: true,
        title: '完课考试'
      }
    },
    {
      path: '/zxxxgl/hgexercises',
      name: 'hgexercises',
      component: hgExercises,
      meta: {
        requiresAuth: true,
        title: '合格测试'
      }
    },
    {
      path: '/zxxxgl/wdxxvideo',
      name: 'wdxxvideo',
      component: wdxxVideo,
      meta: {
        requiresAuth: true,
        title: '在线学习'
      }
    },
    {
      // 作废
      path: '/zxxxgl/xxglksdf',
      name: 'xxglksdf',
      component: xxglksdf,
      meta: { requiresAuth: true }
    },
    {
      path: '/exam/cert',
      name: 'examcert',
      component: examcert
    },
    {
      path: '/test',
      name: 'test',
      component: test
    }
  ]
});

router.beforeEach((to, from, next) => {
  // 排除页面拦截
  $('html,body').animate({ scrollTop: '0px' }, 10)
  // if (to.path !== '/zxxxgl/exercises') {
  //   // 页面滚动
  //   let curTop = document.documentElement.scrollTop || document.body.scrollTop;
  //   if (curTop >= 255) {
  //     $('html,body').animate({ scrollTop: '205px' }, 10)
  //   }
  // }

  // 如果路由不存在，重定向到首页
  if (to.name == null) {
    next({
        name: 'index'
      })
  }

  // 设置标题
  if (to.meta.title) {
    document.title = to.meta.title + ' - ' + ProjectSettings.Title;
  } else {
    switch (ProjectSettings.Name) {
      case 'NCJZJY':
        document.title = '南昌市建筑云培训平台 – 施工现场专业人员（八大员）、三类人员、特种作业人员、技术工人培训、证书办理、证书延期';
        break;
      case 'FZSJZY':
        document.title = '抚州市建筑云培训平台 – 施工现场专业人员（八大员）、三类人员、特种作业人员、技术工人培训、证书办理、证书延期';
        break;
      case 'JASJZY':
        document.title = '江西吉安建筑云培训平台 – 施工现场专业人员（八大员）、三类人员、特种作业人员、技术工人培训、证书办理、证书延期';
        break;
      case 'YCSJZY':
        document.title = '宜春市建筑云培训平台 – 施工现场专业人员（八大员）、三类人员、特种作业人员、技术工人培训、证书办理、证书延期';
        break;
      case 'JJSJZY':
        document.title = '九江市建筑云培训平台 – 三类人员、特种作业人员培训、证书办理、证书延期';
        break;
      case 'XYSJZY':
        document.title = '新余市建筑行业培训网 – 施工现场专业人员（八大员）、三类人员、特种作业人员、技术工人培训、证书办理、证书延期';
        break;

      default:
        document.title = ProjectSettings.Title;
        break;
    }
  }

  if (to.meta.requiresAuth) {
    // 判断该路由是否需要登录权限
    if (Cookies.get('Token')) {
      next();
    } else {
      Cookies.remove('moduleName');
      Cookies.remove('moduleHref');
      Cookies.remove('Token');
      Cookies.remove('UserTypeId');
      Cookies.remove('UserName');
      Cookies.remove('DisplayName');
      Cookies.remove('YYMenus');
      next({
        name: 'index',
        query: {
          redirect: to.fullPath
        }
      })
      // window.top.location.reload();
      // window.top.location.href = 'login';
    }
  } else {
    next();
  }
});

// // 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js